import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Analytics from '../services/analytics';

export const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change
        Analytics.pageView(location.pathname + location.search);
    }, [location]);

    return null;
};
